import { jsxs as d, jsx as i, Fragment as z } from "react/jsx-runtime";
import { useState as B, useEffect as I, useId as H } from "react";
import { c } from "../clsx-OuTLNxxd.js";
import { L as v } from "../Label-BzU1J_9L.js";
import "../PerformanceIndicator.css?__remix_sideEffect__";const w = "320px",M = "600px",$ = "1025px",C = "_isVisuallyHidden_yj44f_52",O = "_performanceIndicator_yj44f_64",L = "_container_yj44f_68",k = "_percentage_yj44f_80",F = "_label_yj44f_88",P = "_indicatorWrapper_yj44f_95",A = "_hasMaxWidth_yj44f_103",R = "_indicator_yj44f_95",V = "_success_yj44f_114",D = "_failure_yj44f_118",E = "_neutral_yj44f_122",U = "_dateTop_yj44f_126",Y = "_dateBottom_yj44f_127",q = "_teamName_yj44f_143",e = {
    mobile: w,
    "mobile-wide": "480px",
    tablet: M,
    "tablet-wide": "800px",
    desktop: $,
    "desktop-mid": "1281px",
    "desktop-large": "1360px",
    "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
    "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
    "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
    "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
    "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
    "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
    "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
    "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
    "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
    "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
    "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
    isVisuallyHidden: C,
    performanceIndicator: O,
    container: L,
    "spacing-s": "_spacing-s_yj44f_74",
    "spacing-m": "_spacing-m_yj44f_77",
    percentage: k,
    label: F,
    indicatorWrapper: P,
    hasMaxWidth: A,
    indicator: R,
    success: V,
    failure: D,
    neutral: E,
    dateTop: U,
    dateBottom: Y,
    teamName: q
  },X = ({
    formatDate: o,
    hasMaxWidth: y = !0,
    history: n,
    hitRate: g,
    label: x,
    limit: m,
    showMatchInformation: f = !1,
    showHitRate: r = !0,
    position: p = "end",
    spacing: u = "m",
    className: S
  }) => {
    const [N, j] = B([]);
    if (!n.length)
    return null;
    I(() => {
      const t = n.sort(
        (a, s) => new Date(s.startTime).getTime() - new Date(a.startTime).getTime()
      ).slice(0, m);
      j(t);
    }, [n, m]);
    const h = (t) => {
        const a = new Date(t),s = a.getMonth() + 1,l = a.getDate();
        return `${s}/${l}`;
      },_ = (t, { showFullName: a } = {}) => {
        const s = t.participant.side === "AWAY",l = s ? t.homeTeam : t.awayTeam,b = a ? l.name : l.shortName;
        return s ? `@${b}` : b || l.name;
      },T = (t) => {
        switch (t) {
          case "WON":
            return e.success;
          case "LOST":
            return e.failure;
          default:
            return e.neutral;
        }
      },W = H();
    return /* @__PURE__ */d("div", { className: c(e.performanceIndicator, S), children: [
      x && /* @__PURE__ */i(v, { className: e.label, htmlFor: W, children: x }),
      /* @__PURE__ */d(
        "div",
        {
          className: c(e.container, e[`spacing-${u}`]),
          id: W,
          role: "group",
          "aria-label": "Performance Indicator",
          style: {
            "--indicator-count": n.length,
            justifyContent: p === "start" ? "flex-end" : "flex-start"
          },
          children: [
          r && /* @__PURE__ */d("span", { className: e.percentage, "data-testid": "hit-rate", children: [
            g,
            "%"]
          }),
          N.map((t, a) => {
            const s = T(t.participant.betResult);
            return /* @__PURE__ */d(
              "div",
              {
                className: c(e.indicatorWrapper, {
                  [e.hasMaxWidth]: y
                }),
                "data-testid": "indicator",
                children: [
                f && /* @__PURE__ */i("span", { className: e.dateTop, "data-testid": "date-top", children: o ? o(t.startTime, "M/d") : h(t.startTime) }),
                /* @__PURE__ */i(
                  "div",
                  {
                    className: c(e.indicator, s),
                    role: "img",
                    "aria-label": `${t.participant.betResult === "WON" ? "Success" : t.participant.betResult === "LOST" ? "Failure" : "Undetermined"} against ${_(t)}`
                  }
                ),
                f && /* @__PURE__ */d(z, { children: [
                  /* @__PURE__ */i("span", { className: e.teamName, children: _(t) }),
                  /* @__PURE__ */i("span", { className: e.dateBottom, "data-testid": "date-bottom", children: o ? o(t.startTime, "M/d") : h(t.startTime) })]
                })]

              },
              a
            );
          })]

        }
      )]
    });
  },Z = ({
    className: o,
    hasMaxWidth: y,
    history: n,
    position: g,
    spacing: x
  }) => {
    if (!n.length)
    return null;
    const m = (r) => {
        switch (r) {
          case "WON":
            return e.success;
          case "LOST":
            return e.failure;
          default:
            return e.neutral;
        }
      },f = H();
    return /* @__PURE__ */i("div", { className: c(e.performanceIndicator, o), children: /* @__PURE__ */i(
        "div",
        {
          className: c(e.container, e[`spacing-${x}`]),
          id: f,
          role: "group",
          "aria-label": "Performance Indicator",
          style: {
            "--indicator-count": n.length,
            justifyContent: g === "start" ? "flex-end" : "flex-start"
          },
          children: n.map((r, p) => {
            const u = m(r);
            return /* @__PURE__ */i(
              "div",
              {
                className: c(e.indicatorWrapper, {
                  [e.hasMaxWidth]: y
                }),
                "data-testid": "indicator",
                children: /* @__PURE__ */i(
                  "div",
                  {
                    className: c(e.indicator, u),
                    role: "img"
                  }
                )
              },
              p
            );
          })
        }
      ) });
  };
export {
  X as PerformanceIndicator,
  Z as TipsterPerformanceIndicator };